import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getPlan } from '@/areas/culture-hub/slices/cultureHubInterventionsSlice';
import { MobilePageContent, MobilePageSection, Title, Subtitle } from '@/mobile/layouts/common/MobilePageStyles';
import { BodyText } from '@/common/styles/page';
import MobileCultureActions from './culture-actions/MobileCultureActions';

const MobileFocusAreaActions: React.FC = () => {
    const location = useLocation();
    const params = useParams();
    const plan = useSelector(getPlan);

    const stateItem = (location.state && (location.state as any).item) as any | undefined;
    let item = stateItem;

    if (!item && params.templateId && typeof params.taskIndex !== 'undefined') {
        const idx = Number(params.taskIndex);
        item = plan.find((p: any) => String(p.recommendation_template_id) === String(params.templateId) && Number(p.task_index) === idx);
    }

    const [isEditorOpen, setIsEditorOpen] = useState(false);

    if (!item) {
        return (
            <MobilePageContent>
                <MobilePageSection>
                    <Title>Action plan not found</Title>
                    <BodyText>No focus area was found for this action plan.</BodyText>
                </MobilePageSection>
            </MobilePageContent>
        );
    }

    return (
        <MobilePageContent>
            {!isEditorOpen && (
                <MobilePageSection padbottom>
                    <Row>
                        <Title>Culture Actions</Title>
                        <Subtitle>{item.task_title || item.title || item.recommendation_name || 'Focus area'}</Subtitle>
                        <BodyText>Track and manage your culture-related actions and their impact.</BodyText>
                    </Row>
                </MobilePageSection>
            )}

            <MobilePageSection>
                <MobileCultureActions
                    actionPlanId={item?.action_plan_id ?? null}
                    onEditorOpen={setIsEditorOpen}
                />
            </MobilePageSection>
        </MobilePageContent>
    );
};

export default MobileFocusAreaActions;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
  flex-wrap: wrap;
`;
